/* eslint-disable no-unused-vars */
import AddMember from './components/add_member/AddMember';
import styles from './index.less?modules';
const MemberManagement = () => {
  return (
    <div className={styles.add_content}>
      <AddMember />
    </div>
  );
};

export default MemberManagement;
